const guid = () => {
  function s4() {
    const array = new Uint16Array(1);
    window.crypto.getRandomValues(array);
    return array[0].toString(16).padStart(4, '0');
  }

  return `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
};

export default guid;
